/**
 * @return {boolean} Возвращает true, если пользователь пользуется темной темой
 * */
export const detectDarkTheme = () => window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
